import { getGsap } from "./GsapGlobals";
import { SplitCharsService } from "./SplitCharsService";

export class SubVisualTitleSplitController {
    static init(): void {
        const title = document.querySelector<HTMLElement>(".no-sub-visual h2");
        if (!title) return;

        SplitCharsService.split(title);

        const gsap = getGsap();
        if (!gsap) return;

        gsap.fromTo(
            title.querySelectorAll<HTMLElement>(".char"),
            { y: "105%", opacity: 0 },
            {
                y: "0%",
                opacity: 1,
                duration: 0.85,
                ease: "power3.out",
                stagger: 0.045,
                delay: 0.15,
            },
        );
    }
}
